import type { AppAbility } from '@app/icare/shared/auth/ability'

import { subjectForTour } from './routeForTour'
import { type TourId, tourSequence } from './types'

export const isEligible = (id: TourId, ability: AppAbility): boolean => ability.can('read', subjectForTour(id))

export const nextEligible = (current: TourId, ability: AppAbility): TourId | null => {
  const i = tourSequence.indexOf(current)
  if (i < 0) return null
  for (let j = i + 1; j < tourSequence.length; j++) {
    if (isEligible(tourSequence[j], ability)) return tourSequence[j]
  }
  return null
}

export const firstEligible = (ability: AppAbility): TourId | null =>
  tourSequence.find(id => isEligible(id, ability)) ?? null
